export default class SummaryPrintHelper {
    setup() {

        const headings = document.querySelectorAll(
            'article.digital-publication h2'
        );

        document.addEventListener('DOMContentLoaded', () => {
            if (headings.length > 0) {
                this.wrapSummaryElements(headings);
            }
        });
    }

    wrapSummaryElements(headings) {
        let resultsSummary = null;
        let summary = null;

        headings.forEach(element => {
            if (element.innerText.trim().toLowerCase() === 'resultat i korthet') {
                resultsSummary = element;
            }

            if (element.innerText.trim().toLowerCase() === 'sammanfattning') {
                summary = element;
            }
        });

        if (resultsSummary && summary) {
            // check to see if resultsSummary h2 and summary h2 are heading siblings
            for (let i = 0; i < headings.length; i++) {
                if (headings[i] === resultsSummary && headings[i + 1] !== summary) {
                    // Only wrap summary if resultsSummary and summary are not heading siblings
                    resultsSummary = null;
                    break;
                }
            }
        }

        if (resultsSummary || summary) {
            const printSummaries = document.querySelectorAll('.print-summary');

            if (printSummaries.length > 0) {
                printSummaries.forEach(printSummary => {
                    printSummary.style.display = 'block';
                });
            }

            const wrapper = document.createElement('div');
            wrapper.classList.add('summary-wrapper');

            if (resultsSummary) {
                let parent = resultsSummary.parentNode;
                let sibling = resultsSummary.nextElementSibling;
                parent.insertBefore(wrapper, sibling);

                wrapper.appendChild(resultsSummary);
                while (sibling && sibling.tagName !== 'H2') {
                    let nextSibling = sibling.nextElementSibling;
                    wrapper.appendChild(sibling);
                    sibling = nextSibling;
                }
            }

            if (summary) {
                let parent = summary.parentNode;
                let sibling = summary.nextElementSibling;

                if (!resultsSummary) {
                    parent.insertBefore(wrapper, sibling);
                }

                wrapper.appendChild(summary);
                while (sibling && sibling.tagName !== 'H2') {
                    let nextSibling = sibling.nextElementSibling;
                    wrapper.appendChild(sibling);
                    sibling = nextSibling;
                }
            }

            // Parent window /www/wp-content/themes/vardanalys/assets/scripts/src/SummaryPrintHelper.js listens for this event
            const event = new CustomEvent('summaryWrapperAdded', {detail: {selector: '.summary-wrapper'}});
            window.parent.document.dispatchEvent(event);
        }
    }
}